import { csx } from '@vtex/admin-ui'

export const styles = {
  container: csx({
    width: '100%',
  }),
  nestedContainer: csx({
    marginTop: '$space-4',
    paddingLeft: '$space-7',
  }),
}
